<div class="tpl-edit">

  <!-- Head -->
  <div class="tpl-edit-head">
    <span class="cat-pill" *ngIf="cat"><i class="bi" [ngClass]="cat.icon"></i>{{ cat.label }}</span>
    <div class="h-text">
      <div class="eyebrow">Edit template</div>
      <h2>{{ template.label }}</h2>
      <div class="sub">Sent to <strong>{{ categorySub }}</strong> when this trigger fires.</div>
    </div>
    <button class="reset-link" (click)="resetToDefault()">
      <i class="bi bi-arrow-counterclockwise"></i>Reset to default
    </button>
    <button class="close-btn" (click)="onClose()" title="Close"><i class="bi bi-x-lg"></i></button>
  </div>

  <!-- Body — form left | preview right -->
  <div class="tpl-edit-body">

    <div class="tpl-form">

      <!-- Available placeholders -->
      <div class="tpl-section" *ngIf="template.placeholders?.length">
        <div class="sec-title"><span class="num">1</span>Available placeholders</div>
        <div class="ph-bar">
          <span class="ph-label">Available:</span>
          <button type="button" class="ph-chip" *ngFor="let p of template.placeholders" (click)="insertPlaceholder(p)">
            <i class="bi bi-plus"></i>{{ '{' + p + '}' }}
          </button>
        </div>
        <div class="ph-help">
          Click a placeholder to insert it at your cursor. Placeholders look like
          <code>{{ '{contractor_name}' }}</code> and get replaced when the email is sent.
        </div>
      </div>

      <!-- Phase 2: Heading section (needs template.heading from API)
      <div class="tpl-section">
        <div class="sec-title"><span class="num">2</span>Heading</div>
        <div class="tpl-field">
          <label>Heading</label>
          <input type="text" class="input-form" [(ngModel)]="template.heading"
            (focus)="setActiveField('heading')" (ngModelChange)="onFieldChange()" />
          <span class="hint">The bold centered title in the email body. Leave blank to omit.</span>
        </div>
      </div>
      -->

      <!-- Subject -->
      <div class="tpl-section">
        <div class="sec-title"><span class="num">2</span>Subject</div>
        <div class="tpl-field">
          <label>Subject line <span class="req">*</span></label>
          <input #subjectInput type="text" class="input-form" [(ngModel)]="template.subject"
            (focus)="setActiveField('subject')" (ngModelChange)="onFieldChange()" />
          <span class="hint">Shown in the recipient's inbox. Keep it under 60 characters.</span>
        </div>
      </div>

      <!-- Greeting -->
      <div class="tpl-section">
        <div class="sec-title"><span class="num">3</span>Greeting</div>
        <div class="tpl-field">
          <label>Greeting</label>
          <input #greetingInput type="text" class="input-form" [(ngModel)]="template.greeting"
            (focus)="setActiveField('greeting')" (ngModelChange)="onFieldChange()" />
          <span class="hint">e.g. <code>Hi {{ '{contractor_first_name}' }},</code></span>
        </div>
      </div>

      <!-- Body -->
      <div class="tpl-section">
        <div class="sec-title"><span class="num">4</span>Body</div>
        <div class="tpl-field">
          <label>Body text <span class="req">*</span></label>
          <textarea #bodyInput class="input-form tpl-body" [(ngModel)]="template.body_text"
            (focus)="setActiveField('body_text')" (ngModelChange)="onFieldChange()"></textarea>
          <span class="hint">Plain text. Double line breaks create paragraphs.</span>
        </div>
      </div>

      <!-- Locked notice -->
      <div class="lock-note">
        <i class="bi bi-lock-fill"></i>
        <div>
          <strong>Template-specific content</strong> (timesheet tables, invoice line items, job info)
          is rendered automatically between the body text and the action button — it can't be
          customized here.
        </div>
      </div>

    </div>

    <!-- Preview -->
    <div class="tpl-preview">
      <div class="preview-tag"><i class="bi bi-eye"></i>Live preview · with sample data</div>

      <div class="mail-card"
        [style.--m-primary]="branding.primary_color"
        [style.--m-bg]="branding.background_color"
        [style.--m-btn]="branding.button_color"
        [style.--m-bg-soft]="bgSoft">
        <div class="strip"></div>
        <div class="logo">
          <span class="mark">{{ sampleAgencyMark }}</span>
          <span>{{ sampleAgency }}</span>
        </div>
        <div class="body">
          <!-- Phase 2: <h2 class="heading" [innerHTML]="headingHtml"></h2> -->
          <p class="greet" [innerHTML]="greetingHtml"></p>
          <div [innerHTML]="bodyHtml"></div>

          <div class="data-block" *ngIf="dataBlock">
            <div class="db-eyebrow"><i class="bi bi-lock-fill"></i>System-generated content</div>
            <div class="db-title">{{ dbTitle }}</div>
            <div class="db-sub">{{ dbSub }}</div>
          </div>

          <div class="cta-wrap">
            <a href="javascript:void(0)" class="cta">{{ cta }}</a>
          </div>
        </div>
        <div class="foot">
          <span class="agency">{{ sampleAgency }}</span>
          <span>{{ footerText }}</span>
        </div>
      </div>

      <div class="preview-sample">
        <i class="bi bi-info-circle"></i>
        Sample data shown — real values are filled in when the email is sent.
      </div>
    </div>
  </div>

  <!-- Foot -->
  <div class="tpl-edit-foot">
    <div class="left" [class.dirty]="dirty">
      <ng-container *ngIf="dirty"><span class="dot"></span>Unsaved changes</ng-container>
      <ng-container *ngIf="!dirty">
        <i class="bi bi-info-circle"></i>
        <span>Changes apply to <strong>all future emails</strong> from this template.</span>
      </ng-container>
    </div>
    <div class="right">
      <span class="save-error" *ngIf="saveError"><i class="bi bi-exclamation-circle"></i>{{ saveError }}</span>
      <button class="btn btn-secondary" (click)="onClose()">Cancel</button>
      <button class="btn btn-primary" (click)="save()" [disabled]="saving">
        <span *ngIf="saving" class="spinner-border spinner-border-sm me-1"></span>
        <i *ngIf="!saving" class="bi bi-check-lg"></i>Save changes
      </button>
    </div>
  </div>

</div>
